import { createStructuredSelector } from 'reselect'

import { selectSfid } from 'modules/Auth/store/selectors'
import { selectBrandQueryParam } from 'modules/Router/store/index'

export const masConsentsGdprSelectors = createStructuredSelector({
  sfid: selectSfid,
  brand: selectBrandQueryParam,
})
